import script from "./DeliveryAddress.vue?vue&type=script&setup=true&lang=ts"
export * from "./DeliveryAddress.vue?vue&type=script&setup=true&lang=ts"

import "./DeliveryAddress.vue?vue&type=style&index=0&id=62743b2b&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-62743b2b"]])

export default __exports__